import { z } from "zod";

export const resourceCostMonthlyResultSchema = z.object({
  "ResourceCostMonthly.date": z.string(),
  "ResourceCostMonthly.currency": z.string().nullish(),
  "ResourceCostMonthly.totalListCost": z.string().nullish(),
  "ResourceCostMonthly.totalBilledCost": z.string().nullish(),
  "ResourceCostMonthly.totalEffectiveCost": z.string().nullish(),
  "ResourceCostMonthly.dailyListCost": z.string().nullish(),
  "ResourceCostMonthly.dailyBilledCost": z.string().nullish(),
  "ResourceCostMonthly.dailyEffectiveCost": z.string().nullish(),
  "ResourceCostMonthly.forecastListCost": z.string().nullish(),
  "ResourceCostMonthly.forecastBilledCost": z.string().nullish(),
  "ResourceCostMonthly.forecastEffectiveCost": z.string().nullish(),
  "AccountId.provider": z.string().nullish(),
  "AccountId.accountId": z.string().nullish(),
  "Account.key": z.string().nullish(),
  "Account.name": z.string().nullish(),
  "Account.groups": z.string().nullish(),
  "ResourceId.resource_key": z.string().nullish(),
});

export const resourceCostMonthlyResultArraySchema = z
  .array(resourceCostMonthlyResultSchema)
  .nullish();

export type ResourceCostMonthlyResult = z.infer<
  typeof resourceCostMonthlyResultSchema
>;
